import React, { useRef, useState } from 'react'
import FormLoader from '../Reusable_Components/FromLoader'
import { FaSearch } from 'react-icons/fa'
import axios from "../../axios-interceptor"
import { useDispatch, useSelector } from 'react-redux'
import { CREATE_PARTNER_COMPANY_FAILURE, CREATE_PARTNER_COMPANY_SUCCESS, createPartnerCompany, SET_LOADER, UPLOAD_DSC_FAILURE, UPLOAD_DSC_SUCCESS, UPLOAD_LOGO_FAILURE, UPLOAD_LOGO_SUCCESS, uploadDscFile, uploadLogo } from '../../Redux/Actions/Actions'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { MdErrorOutline } from 'react-icons/md'
import AlertPopUp from "../Reusable_Components/Alert";
import { base_url } from '../../utilities'
import UploadComponent from '../Reusable_Components/UploadComponent'
import {
    handleCinInputChange, processAndValidateEmail, eleminateSpacesAtStartOfInputField, eleminateSpecialCharactersAtStartOfInputField,
    validateGstNumber, handleKeyPressForGst,
    encrypt
} from "../Reusable_Components/ReusableFunctions";
import { RiLockPasswordLine } from 'react-icons/ri'


export default function AddPartnerCompany(props) {

    const dispatch = useDispatch()
    const childRef = useRef(null)

    const loading = useSelector(state => state.loading)
    const createPartnerCompanySuccess = useSelector(state => state.createPartnerCompanySuccess)
    const createPartnerCompanyError = useSelector(state => state.createPartnerCompanyError)
    const uploadLogoSuccess = useSelector(state => state.uploadLogoSuccess)
    const uploadLogoError = useSelector(state => state.uploadLogoError)
    const uploadDscSuccess = useSelector(state => state.uploadDscSuccess)
    const uploadDscError = useSelector(state => state.uploadDscError)

    const [shortNameError, setShortNameError] = useState('')
    const [gstNumber, setGstNumber] = useState('')
    const [gstLoader, setGstLoader] = useState(false)
    const [companyDetails, setCompanyDetails] = useState({})
    const [slf, setSlf] = useState(false)
    const [water, setWater] = useState(false)
    const [electricity, setElectricity] = useState(false)
    const [fms, setFms] = useState(false)
    const [miscellaneous, setMiscellaneous] = useState(false)
    const [getNumberError, setGetNumberError] = useState(null)
    const [isValidGstNumber, setIsValidGstNumber] = useState(true)
    const [isCinValid, setIsCinValid] = useState(true)
    const [filesData, setFilesData] = useState([])
    const [dscFilesData, setDscFilesData] = useState([])
    const [email, setEmail] = useState('')
    const [shortName, setShortName] = useState('')
    const [emailError, setEmailError] = useState('')
    const [alertShow, setAlertShow] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertValue, setAlertValue] = useState('')
    const [alertButtons, setAlertButtons] = useState([])
    const [errorValue, setErrorValue] = useState(null)
    const [signerNameError, setSignerNameError] = useState(null)

    const [showOtpModal, setShowOtpModal] = useState(false)
    const [otp, setOTP] = useState(['', '', '', '', '', '']);
    const inputRefs = useRef(otp.map(() => React.createRef())); // Create refs for each input field
    const [dscFiles, setDscFiles] = useState([])
    const [isValidOTP, setIsValidOTP] = useState(null)
    const [fileIndex, setFileIndex] = useState(null)
    const [showDscPasswordModal, setShowDscPasswordModal] = useState(false)
    const [dscPassword, setDscPassword] = useState('')

    const [showBackConfirmation, setShowBackConfirmation] = useState(false)
    const handleBackConfirmation = () => setShowBackConfirmation(false);
    const handleProceed = () => {
        setShowBackConfirmation(false);
        // props?.setPage(1)
    }

    const handleGstNumberChange = (e) => {
        const input = e.target.value;
        const { isValid, uppercasedInput } = validateGstNumber(input);
        setGstNumber(uppercasedInput);
        setIsValidGstNumber(isValid);
    };

    const handleCinNumberChange = (e) => {
        handleCinInputChange(e,
            (truncatedInput) => setCompanyDetails({ ...companyDetails, cin: truncatedInput }),
            (isValid) => setIsCinValid(isValid)
        );
    };

    const handleEmail = (e) => {
        const input = e.target.value;
        const { processedInput, isValid } = processAndValidateEmail(input, email);
        setEmail(processedInput);
        if (processedInput === '') {
            setEmailError('Email is required');
        } else if (!isValid) {
            setEmailError('Enter a valid email address');
        } else {
            setEmailError('');
        }
    };

    const getGstDetails = () => {
        setGstLoader(true)
        axios.get(`${base_url}gstPortal/verifyGstin?gst_number=${gstNumber}`)
            .then(res => {
                setCompanyDetails(res.data.data)
                setGstLoader(false)
            })
            .catch((error) => {
                const errorDetails = JSON.parse(error.response.data.error_logs.status_desc);
                const errorMessage = errorDetails[0].ErrorMessage
                setErrorValue(errorMessage);
                setAlertShow(true);
                setAlertType('error');
                setAlertMessage('Error');
                setAlertValue(errorMessage);
                setAlertButtons([
                    {
                        name: 'Close',
                        action: () => {
                            setAlertShow(false);
                        }
                    }
                ]);
                setGetNumberError(error.response.data.message)
                setGstLoader(false);
            });
    }

    const addPartnerCompany = () => {
        let { registered_address, ...obj_without_address } = companyDetails;
        let short_name = shortName.trim();
        let email_id = email.trim();
        let signer_name = companyDetails?.signer_name.trim();
        dispatch(createPartnerCompany({ ...registered_address, ...obj_without_address, slf, water, electricity, fms, misc: miscellaneous, logo: uploadLogoSuccess, dsc: uploadDscSuccess, signer_name: signer_name, short_name: short_name, email: email_id }))
    }

    const selectFile = (files) => {
        const processedFiles1 = [];
        files.forEach((file) => {
            const reader1 = new FileReader();
            reader1.onloadend = function () {
                const base64FileContent = reader1.result.split(",")[1];
                const processedFile1 = {
                    file_obj: base64FileContent,
                    file_name: file.file.name,
                    file_type: file.file.type,
                    file_description: file.description ,
                };
                processedFiles1.push(processedFile1);
                if (processedFiles1.length === files.length) {
                    setFilesData(processedFiles1);
                }
            };
            reader1.readAsDataURL(file.file);
        });
    }

    const selectDscFile = (files) => {
        const processedFiles1 = [];
        files.forEach((file) => {
            const reader1 = new FileReader();
            reader1.onloadend = function () {
                const base64FileContent = reader1.result.split(",")[1];
                const processedFile1 = {
                    file_obj: base64FileContent,
                    file_name: file.file.name,
                    file_type: file.file.type,
                    file_description: file.description ,
                };
                processedFiles1.push(processedFile1);
                if (processedFiles1.length === files.length) {
                    setDscFilesData(processedFiles1);
                }
            };
            reader1.readAsDataURL(file.file);
        });
    }


    const uploadLogoData = (index) => {
        if (gstNumber === '' || !companyDetails?.company_name) {
            dispatch({
                type: UPLOAD_LOGO_FAILURE,
                payload: "Please fill above fields before uploading logo"
            })
        } else {
            dispatch(uploadLogo(
                {
                    "files": [
                        {
                            "file_content": filesData[index]["file_obj"],
                            "object_type": "our_company_logo",
                            "file_type": filesData[index]["file_type"].split("/")[1],
                            "file_name": filesData[index]["file_name"],
                            "flag": null,
                            "file_description": filesData[index]["file_description"] || "",
                            "company_name": companyDetails?.company_name,
                            "user_id": localStorage.getItem("username"),
                        }
                    ]
                }
            ))
        }
    }

    const uploadDscPassowrd = () => {
        let data = {
            gst_number: gstNumber,
            dsc_password: dscPassword,
        }
        axios.put(`${base_url}customers/dscPassword`, data)
            .then((res) => {
                // console.log(res)
            })
            .catch(err => {
                console.log(err)
                dispatch({
                    type: UPLOAD_LOGO_FAILURE,
                    payload: err.response.data.message
                })
            })
    }

    const uploadDsc = (index) => {
        if (gstNumber === '' || !companyDetails?.company_name) {
            dispatch({
                type: UPLOAD_LOGO_FAILURE,
                payload: "Please fill above fields before uploading dsc"
            })
        } else {
            dispatch(uploadDscFile(
                {
                    "files": [
                        {
                            "file_content": dscFilesData[index]["file_obj"],
                            "object_type": "our_company_dsc",
                            "file_type": "pfx",
                            "file_name": dscFilesData[index]["file_name"],
                            "flag": null,
                            "file_description": dscFilesData[index]["file_description"] || "",
                            "company_name": companyDetails?.company_name,
                            "user_id": localStorage.getItem("username"),
                        }
                    ]
                }
            ))
            callChildFunction()
            uploadDscPassowrd()
        }
    }

    const handleChange = (index, event) => {
        const value = event.target.value;
        if (isNaN(value)) return; // Only allow numeric input

        const newOTP = [...otp];
        newOTP[index] = value;
        setOTP(newOTP);

        if (value !== '' && index < inputRefs.current.length - 1) {
            inputRefs?.current[index + 1]?.current?.focus(); // Move focus to the next input field
        }
    };

    const handleKeyDown = (index, event) => {
        if (event.key === 'Backspace') {
            const newOTP = [...otp];
            if (otp[index] === "") {
                if (index > 0) {
                    inputRefs.current[index - 1].current.focus(); // Move focus to the previous input field if backspace is pressed
                }
            } else {
                newOTP[index] = "";
                setOTP(newOTP);
            }
        } else if ((event.key === 'Enter' && index === otp.length - 1) || (event.key === 'Enter' && otp.join('').length === 6)) {
            // handleVerifyOTP()
        }
    };

    const handlePaste = event => {
        event.preventDefault();
        const paste = event.clipboardData.getData('text/plain');
        if (/^\d+$/.test(paste) && paste.length <= 6) {
            const newOTP = [...otp];
            for (let i = 0; i < paste.length; i++) {
                if (i < newOTP.length) {
                    newOTP[i] = paste[i];
                }
            }
            setOTP(newOTP);
        }
    };

    const sendOtp = (files) => {
        dispatch({
            type: SET_LOADER,
            payload: true
        })
        axios.post(`${base_url}authorization/setMFAOTP`, encrypt({
            username: localStorage.getItem("username")
        }))
            .then((res) => {
                setDscFiles(files)
                files && files.length > 0 && setShowOtpModal(true)
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            })
            .catch(err => {
                console.log(err)
                callChildFunction()
                dispatch({
                    type: UPLOAD_LOGO_FAILURE,
                    payload: err.response.data.message
                })
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            })
    }

    const handleVerifyDscOtp = () => {
        selectDscFile(dscFiles)
        dispatch({
            type: SET_LOADER,
            payload: true
        })
        axios.post(`${base_url}authorization/validateMFAOTP`, encrypt({ "username": localStorage.getItem("username"), "otp": otp.join('') }))
            .then((res) => {
                if (res.data.data?.actual_status === "error") {
                    setIsValidOTP(res.data.data?.message)
                    dispatch({
                        type: SET_LOADER,
                        payload: false
                    })
                    return
                }
                else {
                    setOTP(['', '', '', '', '', ''])
                    setShowOtpModal(false)
                    dispatch({
                        type: SET_LOADER,
                        payload: false
                    })
                }
            })
            .catch(err => {
                console.log(err)
                setIsValidOTP(err.response.data.message)
                setOTP(['', '', '', '', '', ''])
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            })
        // setShowOtpModal(false)
    }
    const handlePasswordModal = (index) => {
        setShowDscPasswordModal(true)
        setFileIndex(index)
        // uploadDsc(index)
    }

    const callChildFunction = () => {
        if (childRef.current) {
            childRef.current.childFunction();
        }
    }

    return (
        <div>
            <div className="addUserContainer">
                {loading && <FormLoader />}
                <div className="stepsContainer">
                    <div className="stepsTitle">
                        <h6 style={{ padding: "20px", lineHeight: "0px" }}>Add Our Company</h6>
                    </div>
                    <div className={'stepsCardActive'}>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                            <span style={{ fontWeight: "bold", fontSize: "medium" }}>Company Information</span>
                        </div>
                        <span style={{ fontSize: "small", marginTop: "10px" }}>Our Company Details</span>
                    </div>
                </div>
                <div className="infoContainer">
                    <div>
                        <div className="infoTitle">
                            <h6 style={{ padding: "20px", lineHeight: "0px" }}>Company Information</h6>
                        </div>
                        <div className="infoBody">
                            <div className="infoForm">
                                <div className="d-flex align-items-start justify-content-between flex-wrap gap-3">
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <label className='add-facility-modal-label'>GST Number <span style={{ color: "red" }}>*</span></label>
                                            <input type='text' value={gstNumber} className='form-control' onChange={(e) => handleGstNumberChange(e)} onKeyDown={handleKeyPressForGst} style={{ width: "90%", border: "0.5px solid #9D9D9C" }} />
                                            {!isValidGstNumber && <span className="input-error-text">Invalid GST number</span>}
                                        </div>
                                        {
                                            <div style={{ marginBottom: "0px", display: "flex", alignItems: "start", marginTop: "20px" }}>
                                                <div
                                                    style={{
                                                        background: "grey",
                                                        padding: "9px 10px",
                                                        marginLeft: "-20px",
                                                        borderRadius: "5px",
                                                        opacity: gstNumber === '' || !isValidGstNumber ? 0.3 : 1,
                                                        pointerEvents: gstNumber === '' || !isValidGstNumber ? 'none' : 'auto'
                                                    }}
                                                    className="C-pointer"
                                                    onClick={() => {
                                                        if (gstNumber !== '' && isValidGstNumber) {
                                                            // Add logic for search when gstNumber is not empty
                                                            getGstDetails();
                                                        }
                                                    }}
                                                >
                                                    {gstLoader ? (
                                                        <GstLoader />
                                                    ) : (
                                                        <FaSearch color="white" size={20} style={{ fontWeight: "bolder" }} />
                                                    )}
                                                </div>
                                            </div>

                                        }

                                    </div>
                                    <div>
                                        <label className='add-facility-modal-label'>CIN <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' className='form-control responsive-add-facility-input-fields' value={companyDetails?.cin} onChange={handleCinNumberChange} />
                                        {!isCinValid && <span className='text-danger'>Invalid CIN</span>}
                                    </div>
                                </div>
                                <div className="inputsSection">
                                    <div>
                                        <label className='add-facility-modal-label'>Company Name <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled className='form-control responsive-add-facility-input-fields' title={companyDetails?.company_name} value={companyDetails?.company_name} onChange={(e) => setCompanyDetails({ ...companyDetails, company_name: e.target.value })} />
                                    </div>
                                    <div>
                                        <label className='add-facility-modal-label'>Short Name <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' className='form-control responsive-add-facility-input-fields' value={shortName} onChange={(e) => {
                                            let input = eleminateSpacesAtStartOfInputField(e.target.value)
                                            input = eleminateSpecialCharactersAtStartOfInputField(input)
                                            if (/^[0-9]+$/.test(input)) {
                                                setShortNameError("Short name should not contain numbers")
                                            } else if (input.length < 4 && input.length > 0) {
                                                setShortNameError("Must be at least 4 characters")
                                            } else if (input.length === 0) {
                                                setShortNameError("Short name is required")
                                            } else {
                                                setShortNameError("")
                                            }
                                            setShortName(input.toUpperCase());
                                        }} />
                                        {shortNameError && <span className='text-danger'>{shortNameError}</span>}
                                    </div>
                                    <div>
                                        <label className='add-facility-modal-label'>Email Id <span style={{ color: "red" }}>*</span> </label>
                                        <input type='text' className='form-control responsive-add-facility-input-fields' value={email} onChange={handleEmail} />
                                        <span className='text-danger'>{emailError}</span>
                                    </div>
                                </div>
                                <hr></hr>
                                <b className='d-flex my-4'>Gst Primary Address</b>
                                <div className="inputsSection">
                                    <div>
                                        <label className='add-facility-modal-label'>Door Number <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled className='form-control responsive-add-facility-input-fields' value={companyDetails?.registered_address?.door_number} onChange={(e) => {
                                            setCompanyDetails({ ...companyDetails, registered_address: { ...companyDetails.registered_address, door_number: e.target.value } })
                                        }} />
                                    </div>
                                    <div>
                                        <label className='add-facility-modal-label'>Street Address <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled className='form-control responsive-add-facility-input-fields' value={companyDetails?.registered_address?.street_address_1} onChange={(e) => {
                                            setCompanyDetails({ ...companyDetails, registered_address: { ...companyDetails.registered_address, street_address_1: e.target.value } })
                                        }} />
                                    </div>
                                    <div >
                                        <label className='add-facility-modal-label'>Street Address Lane 2 <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled className='form-control responsive-add-facility-input-fields' value={companyDetails?.registered_address?.street_address_2} onChange={(e) => {
                                            setCompanyDetails({ ...companyDetails, registered_address: { ...companyDetails.registered_address, street_address_2: e.target.value } })
                                        }} />
                                    </div>
                                </div>
                                <div className="inputsSection">
                                    <div>
                                        <label className='add-facility-modal-label'>City <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled className='form-control responsive-add-facility-input-fields' value={companyDetails?.registered_address?.city} onChange={(e) => {
                                            setCompanyDetails({ ...companyDetails, registered_address: { ...companyDetails.registered_address, city: e.target.value } })
                                        }} />
                                    </div>
                                    <div>
                                        <label className='add-facility-modal-label'>State <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled className='form-control responsive-add-facility-input-fields' value={companyDetails?.registered_address?.state} onChange={(e) => {
                                            setCompanyDetails({ ...companyDetails, registered_address: { ...companyDetails.registered_address, state: e.target.value } })
                                        }} />
                                    </div>
                                    <div >
                                        <label className='add-facility-modal-label'>Pincode <span style={{ color: "red" }}>*</span></label>
                                        <input type='number' disabled className='form-control responsive-add-facility-input-fields noSpinArrows'
                                            onWheel={(e) => e.target.blur()}
                                            value={companyDetails?.registered_address?.postal_code} onChange={(e) => {
                                                setCompanyDetails({ ...companyDetails, registered_address: { ...companyDetails.registered_address, postal_code: e.target.value } })
                                            }} />
                                    </div>
                                </div>
                                <div className="inputsSection">
                                    <div className='w-100'>
                                        <label className='add-facility-modal-label'>Upload Logo </label>
                                        <UploadComponent
                                            onFilesSelected={selectFile}
                                            uploadActionClicked={uploadLogoData}
                                            maxNumberOfFiles={1}
                                            uploadedFileData={uploadLogoSuccess && uploadLogoSuccess ? [{ file_name: uploadLogoSuccess?.split("/")[2]?.split("-")[0], file_type: uploadLogoSuccess?.split("/")[2]?.split(".")[1], s3_key: uploadLogoSuccess }] : []}
                                            idType={"our_company_add_logo"}
                                            acceptedFileTypes={".jpeg, .jpg, .png"}
                                        />
                                    </div>
                                </div>
                                <hr></hr>
                                <b className='d-flex my-4'>DSC Information</b>
                                <div className="inputsSection">
                                    <div>
                                        <label className='add-facility-modal-label'>Signer's Name <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' className='form-control responsive-add-facility-input-fields' value={companyDetails?.signer_name} onChange={(e) => {
                                            let value = e.target.value
                                            if (value.length < 3 || value.length > 200) {
                                                setSignerNameError("Must be between 3 to 200 characters")
                                                setCompanyDetails({ ...companyDetails, signer_name: value });
                                            } else {
                                                setSignerNameError(null)
                                                setCompanyDetails({ ...companyDetails, signer_name: value });
                                            }
                                        }} />
                                        <span className='text-danger'>{signerNameError}</span>
                                    </div>
                                </div>
                                <div className="inputsSection">
                                    <div className='w-100'>
                                        <label className='add-facility-modal-label'>Upload DSC (pfx file) <span style={{ color: "red" }}>*</span> </label>
                                        <UploadComponent
                                            onFilesSelected={(files) => {
                                                // Only send OTP if a new file is selected (not just description change)
                                                if (
                                                    files &&
                                                    files.length > 0 &&
                                                    (
                                                        dscFiles.length === 0 ||
                                                        files[0].file.name !== dscFiles[0]?.file?.name
                                                    )
                                                ) {
                                                    sendOtp(files);
                                                }
                                                // Always update dscFiles so description changes still work
                                                setDscFiles(files);
                                            }}
                                            uploadActionClicked={handlePasswordModal}
                                            maxNumberOfFiles={1}
                                            uploadedFileData={uploadDscSuccess && uploadDscSuccess ? [{ file_name: uploadDscSuccess?.split("/")[2]?.split("-")[0], file_type: uploadDscSuccess?.split("/")[2]?.split(".")[1], s3_key: uploadDscSuccess }] : []}
                                            idType={"our_company_add_dsc"}
                                            acceptedFileTypes={".pfx"}
                                            ref={childRef}
                                            dscUpload={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="infoFotter">
                        <div className="button-group d-flex justify-content-end gap-3">
                            <button className="btn btn-primary secondary-button" onClick={() => setShowBackConfirmation(true)}>Back</button>
                            <button className="btn btn-primary primary-button" disabled={
                                gstNumber === '' || !companyDetails?.company_name || !companyDetails?.cin ||
                                !companyDetails?.pan_number || !companyDetails?.registered_address?.door_number || !companyDetails?.registered_address?.street_address_1 ||
                                !companyDetails?.registered_address?.city || !companyDetails?.registered_address?.state || !companyDetails?.registered_address?.postal_code ||
                                !isValidGstNumber || !isCinValid || shortName === '' || email === '' || emailError !== '' || companyDetails?.signers_name === '' || signerNameError || shortNameError
                            } onClick={addPartnerCompany}>Submit</button>
                        </div>
                    </div>
                </div>
                <Modal keyboard={false} backdrop="static" show={showBackConfirmation} onHide={handleBackConfirmation} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <h5>Are you sure you want to go back?</h5>
                    </Modal.Body>
                    <Modal.Footer className="footer" >
                        <Button variant="secondary" className="confirmation" onClick={handleBackConfirmation} >Cancel</Button>
                        <Button variant="secondary" className="confirmation-left"
                            onClick={() => {
                                props?.setPage(1)
                                dispatch({
                                    type: UPLOAD_LOGO_SUCCESS,
                                    payload: null
                                })
                            }}> Proceed</Button>
                    </Modal.Footer>
                </Modal>

                {getNumberError && <Modal keyboard={false} backdrop="static" show={getNumberError} onHide={() => {
                    setGetNumberError(null)
                }
                } centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <MdErrorOutline color='red' style={{ height: "60px", width: "60px", fontWeight: "10px" }} />
                        <h5>Error!</h5>
                        <p className="mb-3">{getNumberError}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => {
                            setGetNumberError(null)
                        }
                        } >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>}
                {createPartnerCompanySuccess && <Modal keyboard={false} backdrop="static" show={createPartnerCompanySuccess} onHide={() => {
                    dispatch({
                        type: CREATE_PARTNER_COMPANY_SUCCESS,
                        payload: null
                    })
                }} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <img src="./images/icons/popper.svg" alt="Party Popper" />
                        <h5>Success!</h5>
                        <p className="mb-3"><b>{companyDetails?.company_name}</b> {createPartnerCompanySuccess}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => {
                            dispatch({
                                type: CREATE_PARTNER_COMPANY_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: UPLOAD_LOGO_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: UPLOAD_DSC_SUCCESS,
                                payload: null
                            })
                            props?.setNavigate(!props?.navigat)
                            props?.setPage(1)
                        }} >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>}
                {createPartnerCompanyError && <Modal keyboard={false} backdrop="static" show={createPartnerCompanyError} onHide={() => {
                    dispatch({
                        type: CREATE_PARTNER_COMPANY_FAILURE,
                        payload: null
                    })
                }} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <MdErrorOutline color='red' style={{ height: "60px", width: "60px", fontWeight: "10px" }} />
                        <h5>Error!</h5>
                        <p className="mb-3">{createPartnerCompanyError}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => {
                            dispatch({
                                type: CREATE_PARTNER_COMPANY_FAILURE,
                                payload: null
                            })
                        }} >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>}
                {uploadLogoError && <Modal keyboard={false} backdrop="static" show={uploadLogoError} onHide={() => {
                    dispatch({
                        type: UPLOAD_LOGO_FAILURE,
                        payload: null
                    })
                }} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <MdErrorOutline color='red' style={{ height: "60px", width: "60px", fontWeight: "10px" }} />
                        <h5>Error!</h5>
                        <p className="mb-3">{uploadLogoError}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => {
                            dispatch({
                                type: UPLOAD_LOGO_FAILURE,
                                payload: null
                            })
                        }} >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>}
                {uploadDscError && <AlertPopUp alertShow={uploadDscError} alertType="error" alertMsg="Error" alertValue={uploadDscError} alertButtons={[{ name: 'Close', action: () => { dispatch({ type: UPLOAD_LOGO_FAILURE, payload: null }) } }]} />}
                <AlertPopUp alertShow={alertShow} alertType={alertType} alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />
                {showOtpModal && <Modal keyboard={false} backdrop="static" show={showOtpModal} centered >
                    <Modal.Header>
                        <Modal.Title><div>
                            Enter OTP
                            <div style={{ fontSize: "14px", color: "gray" }}>OTP has been sent to your mail</div>
                        </div></Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column justify-content-center align-items-center gap-3 w-60">
                        <span className="text-danger" style={{ textAlign: "left", width: "80%", fontSize: "12px" }}>
                            {isValidOTP && isValidOTP?.length > 0 && isValidOTP}
                        </span>
                        <div className="d-flex gap-2">
                            {otp.map((digit, index) => (
                                <input
                                    style={{ width: "50px", height: "50px", fontSize: "20px", textAlign: "center", borderRadius: "5px", border: "1px solid gray" }}
                                    key={index}
                                    type="text"
                                    maxLength="1"
                                    value={digit}
                                    onChange={e => {
                                        handleChange(index, e)
                                    }}
                                    onKeyDown={e => {
                                        handleKeyDown(index, e)
                                    }}
                                    onFocus={(e) => {
                                        e.target.select()
                                        // setIsValidOTP(null)
                                    }}
                                    onPaste={handlePaste}
                                    ref={inputRefs.current[index]}
                                />
                            ))}
                        </div>
                        {/* {timerActive && <div>Resend OTP in : {formatTime(timeLeft)}</div>}
                            {!timerActive && <span className="">Send another OTP? {timeLeft <= 0 ? <Link className="C-pointer" onClick={handleSendOtp}>Resend</Link> : <span title={`Resend in ${timeLeft}`} className="C-pointer" style={{ color: "gray" }}>Resend</span>}</span>} */}
                    </Modal.Body>
                    <Modal.Footer className="footer">
                        <Button variant="secondary" className="secondary-left" onClick={() => {
                            setOTP(['', '', '', '', '', ''])
                            setShowOtpModal(false)
                            callChildFunction()
                            // setIsValidOTP('')
                        }}>Close</Button>
                        <Button variant="secondary" className="secondary" onClick={handleVerifyDscOtp}>Verify</Button>
                    </Modal.Footer>
                </Modal>}
                {showDscPasswordModal && <Modal keyboard={false} backdrop="static" show={showDscPasswordModal} centered >
                    <Modal.Header>
                        <Modal.Title><div>
                            Enter DSC Password
                            <div style={{ fontSize: "14px", color: "gray" }}>DSC Password</div>
                        </div></Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column justify-content-center align-items-center gap-3 w-60">
                        <div className="login-input" style={{ border: `${dscPassword?.length === 0 ? "1px solid red" : "1px solid lightgray"}`, marginTop: "0px" }}>
                            <RiLockPasswordLine />
                            <input
                                type="password"
                                placeholder="Enter DSC Password"
                                value={dscPassword}
                                // onFocus={() => setDscPassword("")}
                                onChange={(e) => setDscPassword(e.target.value)}
                                style={{ width: "100%" }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="footer">
                        <Button variant="secondary" className="secondary-left" onClick={() => {
                            setShowDscPasswordModal(false)
                            setDscPassword('')
                        }}>Close</Button>
                        <Button variant="secondary" className="secondary" onClick={() => {
                            uploadDsc(fileIndex)
                            setShowDscPasswordModal(false)
                            setDscPassword('')
                        }}>Upload</Button>
                    </Modal.Footer>
                </Modal>}
            </div>
        </div>
    )
}


const GstLoader = () => {
    return <Spinner style={{ height: "18px", width: "18px" }} animation="border" variant="light" />
}